import '@/plugins/axios';
import platformConstant from '@/util/PlatformConstant.js'


/**
 * 查询在贷跟踪列表
 */
export const findLoanTrackingList = params => axios.post(platformConstant.host + "/loantracking/loanTrackingList", params).then(data => data)


/**
 * 根据申请id和申请日志类型查询
 */
export const findByApplyAndType = params => axios.post(platformConstant.host + "/applicationReview/findByApplyAndType", params).then(data => data)

/**
 * 修改申请状态
 */
export const updateStateById = params => axios.post(platformConstant.host + "/applicationReview/updateStateById", params).then(data => data)

/**
 * 在贷跟踪详情还款计划
 */
export const findRepaymentPlan = params => axios.post(platformConstant.host + "/loantracking/findRepaymentPlan", params).then(data => data)

/**
 * 在贷跟踪详情借款信息
 */
export const findLoaninformationRep = params => axios.post(platformConstant.host + "/loantracking/findLoaninformationRep", params).then(data => data)

/**
 * 担保人确认(初审)
 */
export const guarantorConfirm = params => axios.post(platformConstant.host + "/applicationReview/guarantorConfirm", params).then(data => data)

/**
 * 可出售(复审)
 */
export const salability = params => axios.post(platformConstant.host + "/applicationReview/salability", params).then(data => data)

/**
 * 申请流程
 */
export const findApplyList = params => axios.post(platformConstant.host + "/applicationReview/applyList", params).then(data => data)

/**
 * 签署合同
 */
export const sign = params => axios.post(platformConstant.host + "/loan/sign", params).then(data => data)

/**
 * 放款
 */
export const loan = params => axios.post(platformConstant.host + "/loan/loan", params).then(data => data)

/**
 * 可用发票详情
 */
export const detailsOfAvailableInvoices = params => axios.post(platformConstant.host + "/invoice/detailsOfAvailableInvoices", params).then(data => data)

/**
 * 初审通过
 */
export const passedThePreliminaryExamination = params => axios.post(platformConstant.host + "/applicationReview/passedThePreliminaryExamination", params).then(data => data)

/**
 * 初审拒绝
 */
export const rejectionOfPreliminaryTrial = params => axios.post(platformConstant.host + "/applicationReview/rejectionOfPreliminaryTrial", params).then(data => data)

/**
 * 复审通过
 */
export const reviewedAndApproved = params => axios.post(platformConstant.host + "/applicationReview/reviewedAndApproved", params).then(data => data)

/**
 * 复审拒绝
 */
export const reviewRejected = params => axios.post(platformConstant.host + "/applicationReview/reviewRejected", params).then(data => data)

/**
 * 获取确权通知书合同url
 */
export const getConfirmationNoticeUrl = params => axios.post(platformConstant.host + "/contract/getConfirmationNoticeUrl", params).then(data => data)

/**
 * 获取借贷合同url
 */
export const getLoanContractUrl = params => axios.post(platformConstant.host + "/contract/getLoanContractUrl", params).then(data => data)

/**
 * 获取审批结果
 */
export const approvalResults = params => axios.post(platformConstant.host + "/platRepayment/approvalResults", params).then(data => data)

/**
 * 根据risk查询公司信息
 */
export const findCorpAndRisk = params => axios.post(platformConstant.host + "/applicationReview/findCorpAndRisk", params).then(data => data)

/**
 * 根据proofsetid查询凭证
 */
export const findByProofSet = params => axios.post(platformConstant.host + "/loantracking/findByProofSet", params).then(data => data)

/**
 * 发票管理-发票查询
 */
export const findInvoiceDetailsPageInfo = params => axios.post(platformConstant.host + "/invoice/findInvoiceDetailsPageInfo", params).then(data => data)
/**
 * 发票管理-额度使用详情
 */
export const findCreditProofAssetsUseInfoByProofId = params => axios.post(platformConstant.host + "/invoice/findCreditProofAssetsUseInfoByProofId", params).then(data => data)
/**
 * 发票管理-根据id,查询发票信息(包含：税额、不含税金额...)
 */
export const findInvoiceInfoByProofId = params => axios.post(platformConstant.host + "/invoice/findInvoiceInfoByProofId", params).then(data => data)
/**
 * 发票管理-导出
 */
export const downloadsExcelDownInvoice = params => exportExcel(platformConstant.host + "/invoice/downloadsExcelDownInvoice", params)
/**
 * 查询明细-导出
 */
export const downloadsExcelDownTransfer = params => exportExcel1(platformConstant.host + "/sysFundAccount/downloadsExcelDownTransfer", params)

/**
 * 查询苏宁明细-导出
 */
 export const downloadsExcelDown = params => exportExcel2(platformConstant.host + "/sysFundAccount/downloadsExcelDown", params)


/**
 * 发票管理-动态修改Invoice根据明码id
 */
export const dynamicUpdateInvoiceById = params => axios.post(platformConstant.host + "/invoice/dynamicUpdateInvoiceById", params).then(data => data)
/**
 * 发票管理-修改授信凭证信息
 */
export const updateCreditProofInfo = params => axios.post(platformConstant.host + "/invoice/updateCreditProofInfo", params).then(data => data)
/**
 * 发票管理-线下支付发票(含session)
 */
export const offlinePaidInvoiceSession = params => axios.post(platformConstant.host + "/invoice/offlinePaidInvoiceSession", params).then(data => data)
/**
 * 发票管理-线上支付发票(含session)
 */
export const onlinePaidInvoiceSession = params => axios.post(platformConstant.host + "/invoice/onlinePaidInvoiceSession", params).then(data => data)
/**
 * 发票管理-批量支付发票(含session)
 */
export const batchOnlinePaidInvoiceSession = params => axios.post(platformConstant.host + "/invoice/batchOnlinePaidInvoiceSession", params).then(data => data)

/**
 * 根据id查询申请
 */
export const findApplyById = params => axios.post(platformConstant.host + "/applicationReview/findApplyById", params).then(data => data)
/**
 * 批量支付发票操作(含session0712)
 */
export const batchOnlinePaidInvoiceOperationSession = params => axios.post(platformConstant.host + "/invoice/batchOnlinePaidInvoiceOperationSession", params).then(data => data)
/**
 * 批量线下支付发票操作(含session0712)
 */
export const batchOfflinePaidInvoiceOperationSession = params => axios.post(platformConstant.host + "/invoice/batchOfflinePaidInvoiceOperationSession", params).then(data => data)
/**
 * 封装导出Excal文件请求
 * @param url
 * @param data
 * @returns {Promise}
 */
//api.js
export function exportExcel(url, options = {}) {
  return new Promise((resolve, reject) => {
    console.log(`${url} 请求数据，参数=>`, JSON.stringify(options))
    axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
    axios({
      method: 'post',
      url: url, // 请求地址
      data: options, // 参数
      responseType: 'blob' // 表明返回服务器返回的数据类型
    }).then(
      response => {
        resolve(response.data)
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        console.log(blob)
        let fileName = "发票导出列表" + '.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          // console.log(2)
          navigator.msSaveBlob(blob, fileName)
        } else {
          // console.log(3)
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      },
      err => {
        reject(err)
      }
    )
  })
}
export function exportExcel1(url, options = {}) {
  return new Promise((resolve, reject) => {
    console.log(`${url} 请求数据，参数=>`, JSON.stringify(options))
    axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
    axios({
      method: 'post',
      url: url, // 请求地址
      data: options, // 参数
      responseType: 'blob' // 表明返回服务器返回的数据类型
    }).then(
      response => {
        resolve(response.data)
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        console.log(blob)
        let fileName = options.subNo+"_资金明细" + '.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          // console.log(2)
          navigator.msSaveBlob(blob, fileName)
        } else {
          // console.log(3)
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      },
      err => {
        reject(err)
      }
    )
  })
}

export function exportExcel2(url, options = {}) {
  return new Promise((resolve, reject) => {
    console.log(`${url} 请求数据，参数=>`, JSON.stringify(options))
    axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
    axios({
      method: 'post',
      url: url, // 请求地址
      data: options, // 参数
      responseType: 'blob' // 表明返回服务器返回的数据类型
    }).then(
      response => {
        resolve(response.data)
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        console.log(blob)
        let fileName = options.name+"_资金明细" + '.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          // console.log(2)
          navigator.msSaveBlob(blob, fileName)
        } else {
          // console.log(3)
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      },
      err => {
        reject(err)
      }
    )
  })
}